var _defs, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_63",
    "data-name": "Group 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.55,
    height: 47.55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 48.406,
    y1: -11.079,
    x2: 48.406,
    y2: -10.185,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#dda228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#aa7c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#7c5b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#563f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#36280a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e1605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0d0902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M-1574.989,353.806a27.5,27.5,0,0,1-27.5,27.5,27.5,27.5,0,0,1-27.5-27.5,27.5,27.5,0,0,1,27.5-27.5A27.5,27.5,0,0,1-1574.989,353.806Z",
    transform: "translate(1629.989 -326.306)",
    fill: "#efdc04",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M-1569.428,341.812c0,6.894-8.216,12.483-18.348,12.483s-18.349-5.589-18.349-12.483,8.216-12.482,18.349-12.482S-1569.428,334.918-1569.428,341.812Z",
    transform: "translate(1615.276 -328.17)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M-1610.273,406.49c0-8.021,8.927-14.524,19.94-14.524s19.938,6.5,19.938,14.524-8.928,14.523-19.938,14.523S-1610.273,414.511-1610.273,406.49Z",
    transform: "translate(1617.834 -366.787)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(12.179 30.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M-1582.908,417.659a16.769,16.769,0,0,1-15.225-9.819,1.065,1.065,0,0,1,.528-1.411,1.065,1.065,0,0,1,1.41.529,14.636,14.636,0,0,0,13.287,8.571,14.638,14.638,0,0,0,13.285-8.571,1.067,1.067,0,0,1,1.411-.529,1.065,1.065,0,0,1,.528,1.411A16.771,16.771,0,0,1-1582.908,417.659Z",
    transform: "translate(1598.229 -406.333)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(16.155 18.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M-1582.36,377.908a2.751,2.751,0,0,1-2.751,2.751,2.752,2.752,0,0,1-2.751-2.751,2.752,2.752,0,0,1,2.751-2.75A2.751,2.751,0,0,1-1582.36,377.908Z",
    transform: "translate(1587.862 -375.158)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.75,
    cy: 2.75,
    rx: 2.75,
    ry: 2.75,
    transform: "translate(17.189)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourColored);
export default __webpack_public_path__ + "static/media/fourColored.2c79ea75833795f594f2f15be7b8f350.svg";
export { ForwardRef as ReactComponent };